// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabEmailsAddButton-moduledropdown__n75Yx FloatingSelectDropdown-moduledropdown__O8nBT";
export { _1 as "dropdown" }
